import { Form, FormInstance } from 'antd';
import styled, { css } from 'styled-components';

export const commonFormCssMixin = css`
  height: inherit;
  overflow-y: auto;
  .ant-form-item {
    padding: 0 10px;
    margin-bottom: 20px;
  }
  .ant-form-item-label {
    margin-left: 5px;
    padding-bottom: 0px;
  }
  .ant-form-item-label > label {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    line-height: 32px;
  }
`;
interface StyledFormProps<FormValues> {
  form: FormInstance<FormValues>;
}

const StyledForm = styled(Form)<StyledFormProps<any>>`
  ${() => commonFormCssMixin};
`;

export default StyledForm;
